export default {
      id: "alert-black-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#alert-black",
      toString: function () {
        return this.url;
      }
    }